const MuiInputLabel = {

};

export default MuiInputLabel;
